import { useCallback } from "react";
import IconButton from "@mui/material/IconButton";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import {
  useGridApiContext,
  useGridSelector,
  gridDetailPanelExpandedRowIdsSelector,
  gridDetailPanelExpandedRowsContentCacheSelector,
} from "@mui/x-data-grid-pro";
import __ from "src/utils/Translations";

export const GridDetailPanelToggleColHeader = () => {
  const apiRef = useGridApiContext();

  const expandedRowIds = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowIdsSelector
  );
  const rowsWithDetailPanels = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowsContentCacheSelector
  );

  const noDetailPanelsOpen = expandedRowIds.size === 0;

  const expandOrCollapseAll = useCallback(() => {
    if (noDetailPanelsOpen) {
      apiRef.current.setExpandedDetailPanels(
        new Set(Object.keys(rowsWithDetailPanels))
      );
    } else {
      apiRef.current.setExpandedDetailPanels(new Set());
    }
  }, [apiRef, noDetailPanelsOpen, rowsWithDetailPanels]);

  const Icon = noDetailPanelsOpen ? UnfoldMoreIcon : UnfoldLessIcon;

  return (
    <IconButton
      size="small"
      tabIndex={-1}
      onClick={expandOrCollapseAll}
      aria-label={
        noDetailPanelsOpen ? __("Rozwiń wszystko") : __("Zwiń wszystko")
      }
    >
      <Icon fontSize="inherit" />
    </IconButton>
  );
};
